import styled from 'styled-components'

import { device } from '@/common/constants/device'

import Text from '@/components/common/Text'
import WrapWithText from 'components/ui/WrapWithText'
import { useTranslations } from 'next-intl'

const selectionList = [
  {
    src: 'search',
    title: 'selectionOfCreatives',
    paragraph: 'selectionOfCreativesP',
  },
  {
    src: 'filter',
    title: 'deepSearchFilters',
    paragraph: 'deepSearchFiltersP',
  },
  {
    src: 'download',
    title: 'downloadingMediaFiles',
    paragraph: 'downloadingMediaFilesP',
  },
  {
    src: 'heart',
    title: 'mySelections',
    paragraph: 'mySelectionsP',
  },
  {
    src: 'barchart',
    title: 'creativeStatistics',
    paragraph: 'creativeStatisticsP',
  },
]

const Wrap = styled.section`
  padding: 2rem 0.5rem 1.5rem 0.5rem;

  @media ${device.tablet} {
    padding: 2rem 0;
  }

  @media ${device.laptop} {
    display: flex;
    gap: 2rem;
    justify-content: center;
    padding: 2rem 0 3.25rem;
  }

  @media ${device.laptopL} {
    gap: 6.25rem;
    padding: 2rem 0 4.125rem;
  }
`

const Title = styled.h2`
  max-width: 650px;
  margin-top: 0.5rem;
  margin-bottom: 0.75rem;
  font-weight: 800;
  font-size: 1.625em;
  line-height: 1.23;
  letter-spacing: -0.02em;

  @media ${device.tablet} {
    margin-top: 1rem;
    margin-bottom: 2rem;
    font-size: 2.5em;
  }

  @media ${device.laptop} {
    width: 480px;
    margin-top: 1rem;
  }

  @media ${device.laptopL} {
    width: 100%;
    margin-top: 1rem;
  }
`

const Container = styled.div`
  @media ${device.tablet} {
    display: flex;
    flex-direction: column-reverse;
  }
`

const ImgWrap = styled.div`
  margin: 0 auto;
  margin-bottom: 1.5rem;
  border-radius: 24px;
  width: 343px;
  height: 217px;

  background: url('/_next_static/landing/selection/bg-laptop.webp') center
      center/178px 184px no-repeat,
    radial-gradient(
      55.95% 70.68% at 73.76% 95.59%,
      rgba(255, 235, 51, 0.52) 0%,
      rgba(0, 0, 0, 0.2236) 100%
    ),
    radial-gradient(
      42.29% 79.88% at 51.09% 86.4%,
      rgba(255, 134, 66, 0.66) 0%,
      rgba(0, 0, 0, 0.2838) 100%
    ),
    radial-gradient(
      30.14% 71.61% at 68.54% 94.66%,
      rgba(106, 103, 218, 0.15) 0%,
      rgba(0, 0, 0, 0.0645) 100%
    ),
    radial-gradient(
      29.17% 69.32% at 31.85% 96.96%,
      rgba(97, 71, 255, 0.79) 0%,
      rgba(0, 0, 0, 0.3397) 100%
    ),
    radial-gradient(
      127.99% 74.99% at 49.9% 91.29%,
      #ff8642 0%,
      rgba(0, 0, 0, 0.43) 100%
    ),
    #15151f;

  @media ${device.tablet} {
    width: 712px;
    height: 405px;
    margin-bottom: 0;
    margin-top: 2.5rem;

    background: url('/_next_static/landing/selection/bg-laptop.webp') center
        center/292px 302px no-repeat,
      radial-gradient(
        55.95% 70.68% at 73.76% 95.59%,
        rgba(255, 235, 51, 0.52) 0%,
        rgba(0, 0, 0, 0.2236) 100%
      ),
      radial-gradient(
        42.29% 79.88% at 51.09% 86.4%,
        rgba(255, 134, 66, 0.66) 0%,
        rgba(0, 0, 0, 0.2838) 100%
      ),
      radial-gradient(
        30.14% 71.61% at 68.54% 94.66%,
        rgba(106, 103, 218, 0.15) 0%,
        rgba(0, 0, 0, 0.0645) 100%
      ),
      radial-gradient(
        29.17% 69.32% at 31.85% 96.96%,
        rgba(97, 71, 255, 0.79) 0%,
        rgba(0, 0, 0, 0.3397) 100%
      ),
      radial-gradient(
        127.99% 74.99% at 49.9% 91.29%,
        #ff8642 0%,
        rgba(0, 0, 0, 0.43) 100%
      ),
      #15151f;
  }

  @media ${device.laptop} {
    display: none;
  }
`

const ImgWrapL = styled.div`
  display: none;

  @media ${device.laptop} {
    display: block;
    width: 386px;

    background: url('/_next_static/landing/selection/bg-laptop.webp') center
        center/292px 302px no-repeat,
      radial-gradient(
        55.95% 70.68% at 73.76% 95.59%,
        rgba(255, 235, 51, 0.52) 0%,
        rgba(0, 0, 0, 0.2236) 100%
      ),
      radial-gradient(
        42.29% 79.88% at 51.09% 86.4%,
        rgba(255, 134, 66, 0.66) 0%,
        rgba(0, 0, 0, 0.2838) 100%
      ),
      radial-gradient(
        30.14% 71.61% at 68.54% 94.66%,
        rgba(106, 103, 218, 0.15) 0%,
        rgba(0, 0, 0, 0.0645) 100%
      ),
      radial-gradient(
        29.17% 69.32% at 31.85% 96.96%,
        rgba(97, 71, 255, 0.79) 0%,
        rgba(0, 0, 0, 0.3397) 100%
      ),
      radial-gradient(
        127.99% 74.99% at 49.9% 91.29%,
        #ff8642 0%,
        rgba(0, 0, 0, 0.43) 100%
      ),
      #15151f;
    border-radius: 40px;
  }

  @media ${device.laptopL} {
    width: 507px;
  }
`

const ContainerL = styled.div``

const List = styled.div``

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  :not(:last-child) {
    margin-bottom: 1.25rem;
  }

  @media ${device.laptop} {
    align-items: flex-start;
  }

  @media ${device.laptopL} {
    align-items: center;
  }
`

const Img = styled.div`
  background-image: url(${({ src }) => src});
  background-color: var(--white);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 15px;
  width: 30px;
  height: 30px;

  border: 1px solid #e0e1e2;
  border-radius: 8px;

  @media ${device.tablet} {
    width: 50px;
    height: 50px;
    background-size: 24px;
  }
`

const ItemDescr = styled.div`
  width: 295px;

  @media ${device.tablet} {
    width: 500px;
  }
`

const ItemDescrTitle = styled.h3`
  margin-bottom: 2px;
  font-weight: 600;
  font-size: 1em;
  line-height: 1.5;
  color: var(--black);

  @media ${device.tablet} {
    font-size: 1.25em;
  }
`

const CustomText = styled(Text)`
  line-height: 1.66;
  letter-spacing: -0.01em;
`

const Selection = () => {
  const t = useTranslations('index')

  return (
    <Wrap id="search">
      <ImgWrapL />
      <ContainerL>
        <WrapWithText
          textKey="searchAndselectionOfCreatives"
          bgColor="purple"
          color="purple"
        />
        <Title>{t('chooseCreativesFor')}</Title>
        <Container>
          <ImgWrap />
          <List>
            {selectionList.map(({ src, title, paragraph }) => (
              <Item key={title}>
                <Img src={`/_next_static/landing/selection/${src}.svg`} />
                <ItemDescr>
                  <ItemDescrTitle>{t(title)}</ItemDescrTitle>
                  <CustomText size="15" sizeT="18" weight="500">
                    {t(paragraph)}
                  </CustomText>
                </ItemDescr>
              </Item>
            ))}
          </List>
        </Container>
      </ContainerL>
    </Wrap>
  )
}

export default Selection
